import network from '@/services/network';
import { ApiKey, ApiResponse, CreateApiKeyRequest } from '@/types';
import { ErrorResponse } from '@/utils';

const getApiKeys = async (): Promise<ApiResponse<ApiKey[]>> => {
  try {
    const { data } = await network.get<ApiResponse<ApiKey[]>>('/api-keys');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createApiKey = async (keyData: CreateApiKeyRequest): Promise<ApiResponse<ApiKey>> => {
  try {
    const { data } = await network.post<ApiResponse<ApiKey>>(
      '/api-keys',
      keyData,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateApiKey = async (
  id: number,
  keyData: Partial<{ name: string; is_active: boolean; expires_at: string | null }>,
): Promise<ApiResponse<ApiKey>> => {
  try {
    const { data } = await network.put<ApiResponse<ApiKey>>(
      `/api-keys/${id}`,
      keyData,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const deleteApiKey = async (id: number): Promise<void> => {
  try {
    await network.delete(`/api-keys/${id}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const apiKeyApi = {
  getApiKeys,
  createApiKey,
  updateApiKey,
  deleteApiKey,
};

export default apiKeyApi;
